export default "__VITE_ASSET__CZVqB8w5__"